
import '@fullcalendar/common/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/timegrid/main.css'

import React from 'react'
import ReactDOM from 'react-dom/client'

import serviceWorkerRegistration  from "./register"
import AppWithState from './components/AppWithState'
import { getNotificationDispatcher } from './util/notifications'
import createApolloClient from './apollo/createApolloClient'
import './styles/index.css'
import 'cross-fetch/polyfill'

const apolloClient = createApolloClient()
const notificationDispatcher = getNotificationDispatcher()




const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <AppWithState
        apolloClient={apolloClient}
        notificationDispatcher={notificationDispatcher}
    />,
)

serviceWorkerRegistration()
